import { render, staticRenderFns } from "./ThirdPartyProfileDefaults.vue?vue&type=template&id=50ace45e&scoped=true&lang=pug&"
import script from "./ThirdPartyProfileDefaults.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyProfileDefaults.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyProfileDefaults.vue?vue&type=style&index=0&id=50ace45e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ace45e",
  null
  
)

export default component.exports